(() => {
    const html = document.getElementsByTagName('html')[0];
    const allContentBlocks = document.querySelectorAll('.rewiews-item-text');
    const reviewsBackdrop = document.querySelector('.reviews-backdrop');
    const reviewsModal = document.querySelector('.reviews-backdrop');
    const closeModalButton = document.querySelector('.hide-full-reviews');
    const nameModal = document.querySelector('.reviews-item-modal .modal-name');
    const dateModal = document.querySelector('.reviews-item-modal .modal-date');
    const textModal = document.querySelector('.reviews-item-modal .modal-text');
    const rateModal = document.querySelector(
        '.reviews-item-modal .modal-rating',
    );

    if (closeModalButton) {
        closeModalButton.addEventListener('click', closeModal);
    }

    if (reviewsBackdrop) {
        reviewsBackdrop.addEventListener('click', closeModal);
    }

    allContentBlocks.forEach(item => {
        const curentReview = item.closest('.reviews-item');
        if (curentReview) {
        const currentOpenButton =
            curentReview.querySelector('.show-full-reviews');
        if (currentOpenButton) {
            currentOpenButton.addEventListener('click', openModal);
        }
        }
    })

    function openModal(e) {
        reviewsBackdrop.classList.remove('hidden');
        html.style.overflow = "hidden";
        const currentButton = e.target;
        const curentReview = currentButton.closest('.reviews-item');
        if (curentReview) {
            const currentName =
                curentReview.querySelector('.reviews-item-name').dataset.name;
            const currentDate =
                curentReview.querySelector('.reviews-item-date').dataset.date;
            const currentText =
                curentReview.querySelector('.rewiews-item-text').dataset.text;
            const currentRate = curentReview.querySelector(
                '.reviews-item-rating-value',
            ).dataset.rate;

            nameModal.textContent = currentName;
            dateModal.textContent = currentDate;
            textModal.textContent = currentText;
            rateModal.textContent = currentRate;
        }
    }

    function closeModal(e) {
        if (e.target !== e.currentTarget) return;
            reviewsBackdrop.classList.add('hidden');
            html.style.overflow = '';
            nameModal.textContent = '';
            dateModal.textContent = '';
            textModal.textContent = '';
            rateModal.textContent = '';
    }

      window.addEventListener('keydown', closeModalByEsc);
      function closeModalByEsc(e) {
          if (e.code === 'Escape') {
            reviewsBackdrop.classList.add('hidden');
            html.style.overflow = '';
            nameModal.textContent = '';
            dateModal.textContent = '';
            textModal.textContent = '';
            rateModal.textContent = '';
          }
      }

})();
